import type {ColSpec} from "../../../components/table/MithraTableHeadColumns";
import {sitColumnLabel} from "../../sitLabels";

export const INITIATIVE_COLUMNS: Array<ColSpec> = [
    {cls: '', txt: sitColumnLabel('title'), columnFieldId: 'title', minWidth: 240},
    {cls: '', txt: sitColumnLabel('owner'), columnFieldId: 'owner__email'},
    {cls: '', txt: sitColumnLabel('company'), columnFieldId: ''},
    {cls: '', txt: sitColumnLabel('category'), columnFieldId: ''},
    {cls: '', txt: sitColumnLabel('leverGroup'), columnFieldId: 'lever__group__title'},
    {cls: '', txt: sitColumnLabel('trafficLight'), columnFieldId: ''},
    {cls: '', txt: sitColumnLabel('stage'), columnFieldId: 'doi_status'},
    {cls: '', txt: sitColumnLabel('farol'), columnFieldId: 'complexity_tier'},
    {cls: '', txt: sitColumnLabel('costSavings'), columnFieldId: 'total_saving'},
    {cls: '', txt: sitColumnLabel('costAvoidance'), columnFieldId: 'total_avoidance'},
    {cls: '', txt: sitColumnLabel('lastModified'), columnFieldId: 'updated'},
    {cls: '', txt: sitColumnLabel('modifiedBy'), columnFieldId: 'responsible__email'},
]

export const INITIATIVE_APPROVAL_COLUMNS: Array<ColSpec> = [
    {cls: '', txt: 'Title', minWidth: 240},
    {cls: '', txt: 'Owner'},
    {cls: '', txt: 'Company'},
    {cls: '', txt: 'Category'},
    {cls: '', txt: 'Lever group'},
    {cls: '', txt: 'Stage'},
    {cls: '', txt: 'Cost Savings'},
    {cls: '', txt: 'Cost Avoidance'},
    {cls: '', txt: 'Finance Approver'},
    {cls: '', txt: 'Status'},
    {cls: '', txt: 'Last Modified'},
    {cls: '', txt: 'Modified By'},
]
